/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React from "react";

function CashierResidualsReportGrid({ requests }: { requests: any[] }) {
  const nf = Intl.NumberFormat();
  const residuals: any[] = [];
  const denominations: any[] = [];

  const cstGrandTotals: any[] = [];
  const rejGrandTotals: any[] = [];
  const dispGrandTotals: any[] = [];
  const shortGrandTotals: any[] = [];
  const excGrandTotals: any[] = [];

  requests.forEach((req: any) => {
    req.cassettes.forEach((cst: any) => {
      const denom = denominations.find(
        (dnm) => dnm.denomination === cst.denomination
      );

      if (!denom) {
        denominations.push({ denomination: cst.denomination });
      }
    });

    const cassettes: any = {};

    req.cassettes.forEach((cst: any) => {
      cassettes[cst.denomination] = cst.sealNo;
    });

    const cstNotes: any = {};

    if (req.cassettesNotes) {
      req.cassettesNotes.forEach((cn: any) => {
        cstNotes[cn.denomination] = cn.notes;
      });
    } else {
      req.replenishments.forEach((rep: any) => {
        cstNotes[rep.denomination] = 0;
      });
    }

    const rjtNotes: any = {};

    if (req.rejectedNotes) {
      req.rejectedNotes.forEach((rn: any) => {
        rjtNotes[rn.denomination] = rn.notes;
      });
    } else {
      req.replenishments.forEach((rep: any) => {
        rjtNotes[rep.denomination] = 0;
      });
    }

    const dispNotes: any = {};

    if (req.dispensed) {
      req.dispensed.forEach((dn: any) => {
        dispNotes[dn.denomination] = dn.notes;
      });
    } else {
      req.replenishments.forEach((rep: any) => {
        dispNotes[rep.denomination] = 0;
      });
    }

    const shortages: any = {};

    if (req.shortages) {
      req.shortages.forEach((dn: any) => {
        shortages[dn.denomination] = dn.notes;
      });
    } else {
      req.replenishments.forEach((rep: any) => {
        shortages[rep.denomination] = 0;
      });
    }

    const excesses: any = {};

    if (req.excesses) {
      req.excesses.forEach((dn: any) => {
        excesses[dn.denomination] = dn.notes;
      });
    } else {
      req.replenishments.forEach((rep: any) => {
        excesses[rep.denomination] = 0;
      });
    }

    const resInfo = {
      serialNo: req.serialNo,
      locationId: req.locationId,
      boxSealNo: req.boxSealNo,
      pouchBagSealNo: req.pouchBagSealNo,
      journalRoll: req.journalRoll,
      capturedCardsActual: req.capturedCardsActual,
      rejectBinSealNo: req.rejectBinSealNo,
      cassettes,
      cstNotes,
      rjtNotes,
      dispNotes,
      shortages,
      excesses,
    };

    residuals.push(resInfo);

    cstGrandTotals.push(cstNotes);
    rejGrandTotals.push(rjtNotes);
    dispGrandTotals.push(dispNotes);
    shortGrandTotals.push(shortages);
    excGrandTotals.push(excesses);
  });

  return (
    <div className="w-full">
      <table width="100%">
        <thead>
          <tr>
            <th
              rowSpan={2}
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                textAlign: "center",
                paddingLeft: "2px",
              }}
            >
              Sr. #
            </th>
            <th
              rowSpan={2}
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                textAlign: "left",
                paddingLeft: "2px",
              }}
            >
              Location Id
            </th>
            <th
              rowSpan={2}
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                textAlign: "left",
                paddingLeft: "2px",
              }}
            >
              Incoming Box Seal
            </th>
            <th
              rowSpan={2}
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                textAlign: "left",
                paddingLeft: "2px",
              }}
            >
              Pouch Bag Seal
            </th>
            <th
              rowSpan={2}
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                textAlign: "center",
                paddingLeft: "2px",
              }}
            >
              Journal Roll
            </th>
            <th
              rowSpan={2}
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                textAlign: "center",
                paddingLeft: "2px",
              }}
            >
              Captured Cards
            </th>
            <th
              rowSpan={2}
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                textAlign: "left",
                paddingLeft: "2px",
              }}
            >
              Reject Bin/Cash Bag Seal
            </th>
            <th
              colSpan={denominations.length}
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
              }}
            >
              Cassettes Seals
            </th>
            <th
              colSpan={denominations.length}
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
              }}
            >
              Received in Cassettes Notes
            </th>
            <th
              colSpan={denominations.length}
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
              }}
            >
              Received in Bin Notes
            </th>
            <th
              colSpan={denominations.length}
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
              }}
            >
              Dispensed Notes
            </th>
            <th
              colSpan={denominations.length}
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
              }}
            >
              Shortages
            </th>
            <th
              colSpan={denominations.length}
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
              }}
            >
              Excess
            </th>
          </tr>
          <tr>
            {denominations.map((dnm, i) => {
              return (
                <th
                  key={`repl${i}`}
                  style={{
                    textAlign: "center",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                  }}
                >
                  {dnm.denomination}
                </th>
              );
            })}

            {denominations.map((dnm, i) => {
              return (
                <th
                  key={`disp${i}`}
                  style={{
                    textAlign: "center",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                  }}
                >
                  {dnm.denomination}
                </th>
              );
            })}

            {denominations.map((dnm, i) => {
              return (
                <th
                  key={`cst${i}`}
                  style={{
                    textAlign: "center",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                  }}
                >
                  {dnm.denomination}
                </th>
              );
            })}

            {denominations.map((dnm, i) => {
              return (
                <th
                  key={`rej${i}`}
                  style={{
                    textAlign: "center",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                  }}
                >
                  {dnm.denomination}
                </th>
              );
            })}

            {denominations.map((dnm, i) => {
              return (
                <th
                  key={`short${i}`}
                  style={{
                    textAlign: "center",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                  }}
                >
                  {dnm.denomination}
                </th>
              );
            })}

            {denominations.map((dnm, i) => {
              return (
                <th
                  key={`excess${i}`}
                  style={{
                    textAlign: "center",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                  }}
                >
                  {dnm.denomination}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {residuals.map((res, i) => {
            return (
              <tr key={`row${i}`}>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                    paddingLeft: "2px",
                    width: "80px",
                  }}
                >
                  {res.serialNo}
                </td>
                <td
                  style={{
                    textAlign: "left",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                    paddingLeft: "2px",
                  }}
                >
                  {res.locationId}
                </td>
                <td
                  style={{
                    textAlign: "left",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                    paddingLeft: "2px",
                  }}
                >
                  {res.boxSealNo}
                </td>
                <td
                  style={{
                    textAlign: "left",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                    paddingLeft: "2px",
                  }}
                >
                  {res.pouchBagSealNo}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                    paddingLeft: "2px",
                  }}
                >
                  {res.journalRoll}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                    paddingLeft: "2px",
                  }}
                >
                  {res.capturedCardsActual}
                </td>
                <td
                  style={{
                    textAlign: "left",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                    paddingLeft: "2px",
                  }}
                >
                  {res.rejectBinSealNo}
                </td>

                {denominations.map((dnm, ind) => {
                  const denom = dnm.denomination;
                  return (
                    <td
                      key={`rn${ind}`}
                      style={{
                        textAlign: "center",
                        border: "0.02rem solid grey",
                        fontSize: "0.6rem",
                      }}
                    >
                      {res.cassettes[denom]}
                    </td>
                  );
                })}

                {denominations.map((dnm, ind) => {
                  const denom = dnm.denomination;
                  return (
                    <td
                      key={`cn${ind}`}
                      style={{
                        textAlign: "center",
                        border: "0.02rem solid grey",
                        fontSize: "0.6rem",
                      }}
                    >
                      {res.cstNotes[denom] ? nf.format(res.cstNotes[denom]) : 0}
                    </td>
                  );
                })}

                {denominations.map((dnm, ind) => {
                  const denom = dnm.denomination;
                  return (
                    <td
                      key={`rjn${ind}`}
                      style={{
                        textAlign: "center",
                        border: "0.02rem solid grey",
                        fontSize: "0.6rem",
                      }}
                    >
                      {res.rjtNotes[denom] ? nf.format(res.rjtNotes[denom]) : 0}
                    </td>
                  );
                })}

                {denominations.map((dnm, ind) => {
                  const denom = dnm.denomination;
                  return (
                    <td
                      key={`dn${ind}`}
                      style={{
                        textAlign: "center",
                        border: "0.02rem solid grey",
                        fontSize: "0.6rem",
                      }}
                    >
                      {res.dispNotes[denom]
                        ? nf.format(res.dispNotes[denom])
                        : 0}
                    </td>
                  );
                })}

                {denominations.map((dnm, ind) => {
                  const denom = dnm.denomination;
                  return (
                    <td
                      key={`dn${ind}`}
                      style={{
                        textAlign: "center",
                        border: "0.02rem solid grey",
                        fontSize: "0.6rem",
                      }}
                    >
                      {res.shortages[denom]
                        ? nf.format(res.shortages[denom])
                        : 0}
                    </td>
                  );
                })}

                {denominations.map((dnm, ind) => {
                  const denom = dnm.denomination;
                  return (
                    <td
                      key={`dn${ind}`}
                      style={{
                        textAlign: "center",
                        border: "0.02rem solid grey",
                        fontSize: "0.6rem",
                      }}
                    >
                      {res.excesses[denom] ? nf.format(res.excesses[denom]) : 0}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
        <tfoot>
          <tr>
            <td
              colSpan={denominations.length + 7}
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.7rem",
                fontWeight: "bold",
                textAlign: "center",
                paddingLeft: "2px",
              }}
            >
              Total
            </td>

            {denominations.map((dnm, i) => {
              const denom = dnm.denomination;
              let total = 0;

              cstGrandTotals.forEach((ct: any) => {
                total += ct[denom] ? ct[denom] : 0;
              });
              return (
                <td
                  key={i}
                  style={{
                    border: "0.02rem solid grey",
                    fontSize: "0.7rem",
                    fontWeight: "bold",
                    textAlign: "center",
                    paddingLeft: "2px",
                  }}
                >
                  {nf.format(total)}
                </td>
              );
            })}

            {denominations.map((dnm, i) => {
              const denom = dnm.denomination;
              let total = 0;

              rejGrandTotals.forEach((ct: any) => {
                total += ct[denom] ? ct[denom] : 0;
              });
              return (
                <td
                  key={i}
                  style={{
                    border: "0.02rem solid grey",
                    fontSize: "0.7rem",
                    fontWeight: "bold",
                    textAlign: "center",
                    paddingLeft: "2px",
                  }}
                >
                  {nf.format(total)}
                </td>
              );
            })}

            {denominations.map((dnm, i) => {
              const denom = dnm.denomination;
              let total = 0;

              dispGrandTotals.forEach((ct: any) => {
                total += ct[denom] ? ct[denom] : 0;
              });
              return (
                <td
                  key={i}
                  style={{
                    border: "0.02rem solid grey",
                    fontSize: "0.7rem",
                    fontWeight: "bold",
                    textAlign: "center",
                    paddingLeft: "2px",
                  }}
                >
                  {nf.format(total)}
                </td>
              );
            })}

            {denominations.map((dnm, i) => {
              const denom = dnm.denomination;
              let total = 0;

              shortGrandTotals.forEach((ct: any) => {
                total += ct[denom] ? ct[denom] : 0;
              });
              return (
                <td
                  key={i}
                  style={{
                    border: "0.02rem solid grey",
                    fontSize: "0.7rem",
                    fontWeight: "bold",
                    textAlign: "center",
                    paddingLeft: "2px",
                  }}
                >
                  {nf.format(total)}
                </td>
              );
            })}

            {denominations.map((dnm, i) => {
              const denom = dnm.denomination;
              let total = 0;

              excGrandTotals.forEach((ct: any) => {
                total += ct[denom] ? ct[denom] : 0;
              });
              return (
                <td
                  key={i}
                  style={{
                    border: "0.02rem solid grey",
                    fontSize: "0.7rem",
                    fontWeight: "bold",
                    textAlign: "center",
                    paddingLeft: "2px",
                  }}
                >
                  {nf.format(total)}
                </td>
              );
            })}
          </tr>
        </tfoot>
      </table>
    </div>
  );
}

export default React.memo(CashierResidualsReportGrid);
